/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Cancel_DescInputs */

const vi_order_cancel_desc = /** @type {(inputs: Order_Cancel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập lý do hủy đơn (tối thiểu 3 ký tự)`)
};

/**

* @param {Order_Cancel_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_cancel_desc = /** @type {((inputs?: Order_Cancel_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Cancel_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_cancel_desc(inputs)
});